<div class="inspiration">
  <div class="label"
       [innerText]="'Inspiration'"
  ></div>
  <div class="value"
       [innerText]="&nbsp;"
  ></div>
</div>
